import * as React from 'react';

export const CKBannerGroup: React.FC = ({ children }) => {
  return <div className="ck-banner-group">{children}</div>;
};
